module.exports = __webpack_public_path__ + "static/media/reports_new.ccabf515.svg";